{{data.message}} <button class="mat-simple-snackbar-action" *ngIf="hasAction" (click)="action()">{{data.action}}</button>


// WEBPACK FOOTER //
// ./node_modules/@angular/material/snack-bar/typings/index.d.ts.SimpleSnackBar.html